import { getCode, confirmCode } from '@/axios/api/myProfile'
const state = {
}
const getters = {
}

const mutations = {
}

const actions = {
  // 获取code
  async getCodeApi ({ commit }, params) {
    try {
      let res = await getCode(params)
      return res.errorCode === 200
    } catch (e) {
      return false
    }
  },
  // 提交code
  async confirmCodeApi ({ commit }, params) {
    try {
      let res = await confirmCode(params)
      return res.errorCode === 200
    } catch (e) {
      return false
    }
  },
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/myProfile.js